
import Vue, { PropType } from "vue";
import { InputValidationRules } from "vuetify";
import NumberInput from "./NumberInput.vue";
export default Vue.extend({
  components: {
    NumberInput,
  },
  props: {
    value: String,
    rules: {
      type: Array as PropType<InputValidationRules>,
      default: () => [] as InputValidationRules,
    },
    readonly: Boolean,
    disabled: Boolean,
    messages: String,
    dayOnly: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      h: "00",
      m: "00",
      errorMessages: [] as string[],
    };
  },
  inject: {
    form: { default: null },
  },
  computed: {
    // pos(): string {

    //   return (
    //     this.$refs.h &&
    //     (this.$refs.h as HTMLInputElement).selectionStart + " " + (this.$refs.h as HTMLInputElement).selectionEnd
    //   );
    // },
    compbinedRules(): any[] {
      return this.rules.concat([this.$validation.required(), this.rule]);
    },
    shouldValidate(): boolean {
      return !this.readonly && !this.disabled;
    },
    hasError(): boolean {
      return !!this.errorMessages.length;
    },
  },
  methods: {
    validate(force?: boolean, value?: any): boolean {
      if (force) {
        this.errorMessages = this.compbinedRules.map(r => r(`${this.h}:${this.m}`)).filter(r => r !== true);
      }
      return this.hasError;
    },
    reset() {},
    resetValidation() {
      this.errorMessages = [];
    },
    onFocusHour() {
      this.h = this.h.replace(/0([0-9]+)$/, "$1");
    },
    onFocusMinute() {
      this.h = this.h.replace(/0([0-9]+)$/, "$1");
    },

    rule(v: string): boolean | string {
      if (!v) {
        return true;
      }

      const m = v.match(/^([0-9]*):([0-9]{1,2})$/);

      if (m && (parseInt(m[1]) <= 23 || !this.dayOnly) && parseInt(m[2]) < 60) {
        return true;
      }

      return this.$t("validation.time").toString();
    },
    onInput() {
      this.$emit("input", `${this.h}:${this.m}`);
      this.validate(true);
    },
  },
  watch: {
    value: {
      immediate: true,
      handler(v: string) {
        const parts = (v || "00:00").split(":");
        this.h = parts[0].padStart(2, "0");
        this.m = parts[1].padStart(2, "0");
      },
    },
  },
  created() {
    const frm = (this as any).form;
    frm && frm.register(this);
  },
  beforeDestroy() {
    const frm = (this as any).form;
    frm && frm.unregister(this);
  },
});
